import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {loadClients, saveClient, deleteClient, unLinkMyob} from '../../actions/clientActions';
import { Button} from 'reactstrap';
import Select from 'react-select';
import {toastr} from 'react-redux-toastr';
import {apiRequest} from '../../utils/request';
import AddressesView from '../Addresses/AddressesView';
import CommunicationsView from '../Communications/CommunicationsView';
import ContactsView from '../Contacts/ContactsView';
import ContractsView from '../Contracts/ContractsView';
import moment from 'moment';
import TextBoxControl from '../Common/TextBoxControl';
import CheckBoxControl from '../Common/CheckBoxControl';
import {
  allowUserWithRoles,
  BASE_URL,
  ROLE_Admin, ROLE_BDM,
  ROLE_ClientUser,
  ROLE_LocationUser,
  ROLE_OfficeUser,
  ROLE_SalesManager,
  ROLE_SuperUser
} from "../../constants";
import { push } from '../../utils/navigation';
import UsersByClientLocationControl from "../Users/UsersByClientLocationControl";
import {NewAddress} from "../Addresses/AddressView";
import ExistingClientLocaion from "../Common/ExistingClientLocation";
import { requestHasError, trimWhiteSpaces } from '../../utils/lib';
import { isValidAbn, isValidAccountName } from '../../utils/validations';
import { withRouter } from '../../utils/withRouter';
import {loadBdms} from "../../actions/bdmActions";

export const NewClient = (withDefault = true) => {
  return {
    id: -1,
    companyName: '',
    isInactive: false,
    businessDevelopmentManagerId: null,
    abn: '',
    addresses: withDefault ? [{...NewAddress(0), addressType: 'Business Registered', isPrimary: true}] : [], 
    communications: [],
    contacts: [],
    isGst: false,
    setupComplete: false,
    completedBy: null,
    locations: [],
  };
};

class EditClientView extends React.Component {
  constructor(props, context) {
    super(props, context);

    let isNewClient = this.props.clientId === -1;
    
    this.state = {
      client: isNewClient ? NewClient(false) : null,
      isNewClient,
      originalClient: null,
      message: '',
    };

    this.handleSaveClient = this.handleSaveClient.bind(this);
    this.handleSearchFieldChange = this.handleSearchFieldChange.bind(this);
    this.handleClientFieldChange = this.handleClientFieldChange.bind(this);
    this.handleBdmChange = this.handleBdmChange.bind(this);
    this.validateClient = this.validateClient.bind(this);
    this.handleDeleteClient = this.handleDeleteClient.bind(this);
    this.loadClient = this.loadClient.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }

  handleSearchFieldChange(e) {
    let x = {...this.state.search};

    x[`${e.target.name}`] = e.target.value;

    this.setState({search: x});
  }

  handleClientFieldChange(e) {
    let x = {...this.state.client};

    if(e.target.name === "setupComplete") {
      x['completedBy'] = e.target.checked ? this.props.account.user.id : null;
      x[`${e.target.name}`] = e.target.checked;
    } else if(e.target.type === "checkbox"){
      x[`${e.target.name}`] = e.target.checked;
    } else {
      x[`${e.target.name}`] = e.target.value;
    }

    this.setState({client: x});
  }  

  handleBdmChange(val){
    let client = {...this.state.client};
    client.businessDevelopmentManagerId = val;
    this.setState({client});
  }

  handleSaveClient(){
    if(this.props.clients.saveInfo.saving){
      return;
    }
    //TODO: get the state of the addresses and communications
    let {valid} = this.validateClient();
    if(valid){
      this.props.dispatch(saveClient({...this.state.client, companyName: trimWhiteSpaces(this.state.client.companyName)}));
    }
  }

  handleDeleteClient(){
    if(confirm('Are you sure you want to delete this client?')){
      this.props.dispatch(deleteClient(this.state.client));
      this.setState({client: null});
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (!prevProps.clients.saveInfo.saved && this.props.clients.saveInfo.saved) {
      if (this.props.clients.saveInfo.isNew) {
        this.props.dispatch(push(`${BASE_URL}/manage/clients/${this.props.clients.saveInfo.client.id}`));
      } else if (this.props.clients.saveError.client === undefined) {
        this.props.navigate(-1);
      }
    }

    if (prevProps.clientId !== this.props.clientId) {
      this.loadClient();
    }
  }

  routerWillLeave(nextLocation) {    
    return true;
  }

  componentDidMount() {
    if(this.props.router) {
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
    }
    console.log("hello", this.props.bdms.loaded);
    if(!this.props.bdms.loaded){
      console.log("hello", this.props.bdms.loaded);
      this.props.dispatch(loadBdms());  
    }
    
    
    if(!this.state.isNewClient){
      this.loadClient();
    }
  }

  loadClient(){
    let url = `/api/clients?clientId=${this.props.clientId}`;
    apiRequest(url)
      .then(x => {
        if(x && x.error){
          let message = `You don't yet have access to this client, please wait until any authorisation requests are approved`;
          toastr.warning(message);
          this.setState({message, client: null, originalClient: null});
        } else {
          this.setState({client: x.data[0], message: '', originalClient: {...x.data[0]}});
        }
      });
  }

  handleUnlinkMyob = () => {
    const {client} = this.state;
    this.props.dispatch(unLinkMyob({id: client && client.id, isClient: true})).then(resp => {
      if(!requestHasError({x: resp})){
        toastr.success("Unlinked supplier in MYOB");
        this.setState({client: {...this.state.client, myobID: null}, originalClient: {...this.state.originalClient, myobID: null}});
      }
    });
  }

  validateClient(){
    let {client} = this.state;
    if(client){
      if(trimWhiteSpaces(client.companyName)==='') {
        return {valid: false, error: 'Company name must be provided'};
      }
      // Max allowed client name length is 50 characters
      if(trimWhiteSpaces(client.companyName).length > 50){
        return {valid: false, error: 'Company name must less than 50 characters'};
      }
      if(client.accountBsb && client.accountBsb.trim() != '' && !client.accountBsb.match(/^\d{3}\-\d{3}$/g)){
        return {valid: false, error: 'BSB must be in format ###-###'};
      }
      if(client.accountName && client.accountName.trim()!='' || client.accountBsb && client.accountBsb.trim()!='' || client.accountNumber && client.accountNumber.trim()!='') {
        if (!client.accountName || client.accountName.trim() == '' || !client.accountBsb || client.accountBsb.trim() == '' || !client.accountNumber || client.accountNumber.trim() == '') {
          return {valid: false, error: 'Please complete financial details'};
        }
        if(!isValidAccountName(client.accountName)){
          return {valid: false, error: 'Account name is invalid. '};
        }
      }
      // Validate accounter number - cannot be more than 9 characters
      if(trimWhiteSpaces(client.accountNumber).length > 9){
        return {valid: false, error: 'Account Number must be less than 9 characters'};
      }
      // Validate ABN to specific format
      if(!isValidAbn(client.abn)){
        return {valid: false, error: 'ABN must be in format ## ### ### ###'};
      }
      if(this.refs.addresses && this.refs.communications) {
        let addresses = this.refs.addresses.getCurrentState();
        let communications = this.refs.communications.getCurrentState();
        if (addresses == null || communications == null) {
          return {valid: false, error: 'Must complete address or communication details'};
        }
      }
    }
    return {valid: true, error: ''};
  }

  render(){
    let {client} =  this.state;
    let {isSuperUser, isClientUser, isLocationUser, account, isSalesManager} = this.props;
    let clientValid = this.validateClient();
    const isAdmin = allowUserWithRoles(account, [ROLE_Admin, ROLE_SuperUser, ROLE_OfficeUser]) && 
        !allowUserWithRoles(account, [ROLE_BDM]);

    return client ? (<div>
      <h6>Edit Client</h6>
      {client && <div className="container">

        <div className="row">
          <div className="col-12">
            <div className="form-horizontal">
              <div className="form-group row">
                <h4>{client.companyName}&nbsp;&nbsp;<a href="#"
                                                               className="text-muted"
                                                               onClick={(e)=> {
                                                                 e.preventDefault();
                                                                 if (isSalesManager || JSON.stringify(this.state.client) === JSON.stringify(this.state.originalClient) ||
                                                                   confirm('Are you sure you want to leave without saving your changes?')) {
                                                                   this.props.navigate(-1);
                                                                 }}}>back...</a></h4>
              </div>
              {client.id > 0 && <div className="form-group row">
                <div className="col-9">
                  {client.locationsCount == 0 ?
                    <Button color="danger" sonClick={this.handleDeleteClient}><i className="fa fa-trash" /> Delete</Button>
                    : <span className="text-danger">This client cannot be deleted as it has {client.locationsCount} location(s)</span>
                  }
                </div>
              </div> }

              <TextBoxControl
                 value={client.companyName}
                 onChange={this.handleClientFieldChange}
                 name="companyName"
                 labelText="Company Name" />

              <div className="form-group row">
                <div className="col-8 offset-2">
                  <ExistingClientLocaion name={client.companyName} mode={'client'} />
                </div>
              </div>

            <TextBoxControl
                   value={client.abn == null ? '' : client.abn}
                   onChange={this.handleClientFieldChange}
                   name="abn"
                   labelText="ABN" 
                   fieldType="abn"
            />


              <div className="form-group row">
                <label className="col-2 form-control-label" htmlFor="bdmId">BDM</label>
                <div className="col-8">
                  {isAdmin ? <Select
                    name="bdmId"
                    value={client.businessDevelopmentManagerId}
                    simpleValue
                    options={this.props.bdms.items}
                    valueKey="id"
                    labelKey="fullName"
                    onChange={this.handleBdmChange}
                    clearable                    
                  /> :
                      this.props.bdms.items.find(b => b.id===client.businessDevelopmentManagerId).fullName 
                  }
                </div>
              </div>

              {
                client && client.myobID && <Button color="success" className="mt-1 mb-1" onClick={this.handleUnlinkMyob}>Unlink Supplier in MYOB</Button>
              }

              { isAdmin && <h6>Account Information</h6> }

                <TextBoxControl
                  name={'accountName'}
                  value={client.accountName}
                  onChange={this.handleClientFieldChange}
                  labelText={'Account Name'}
                  visible={isAdmin}
                />
                <TextBoxControl
                  name={'accountBsb'}
                  value={client.accountBsb}
                  onChange={this.handleClientFieldChange}
                  labelText={'Account BSB'}
                  visible={isAdmin}
                />
                <TextBoxControl
                  name={'accountNumber'}
                  value={client.accountNumber}
                  onChange={this.handleClientFieldChange}
                  labelText={'Account Number'}
                  visible={isAdmin}
                />

                {client.dateCreated && isAdmin && <div className="form-group row">
                  <label className="col-3 form-control-label">Date Created</label>
                  <div className="col-9">
                    {moment(client.dateCreated).format('DD/MM/YYYY LT')}
                  </div>
                </div>}

                {client.dateModified && isAdmin && <div className="form-group row">
                  <label className="col-3 form-control-label">Date Modified</label>
                  <div className="col-9">
                    {moment(client.dateModified).format('DD/MM/YYYY LT')}
                  </div>
                </div>}


              <CheckBoxControl
                name={'isActive'}
                value={!client.isInactive}
                onChange={(e)=> this.setState({client: {...client, isInactive: !e.target.checked}})}
                labelText={'Is Active'}
                visible={isAdmin}
              />

            <CheckBoxControl
              name={'isGst'}
              value={client.isGst}
              onChange={this.handleClientFieldChange}
              labelText={'Is GST'}
              visible={isAdmin}
            />

            <CheckBoxControl
              name={'setupComplete'}
              value={client.setupComplete}
              onChange={this.handleClientFieldChange}
              labelText={'Setup Complete'}
              visible={isAdmin}
            />


              <AddressesView
                addresses={client.addresses}
                ref="addresses"
                onChange={(addresses)=> this.setState({client: {...this.state.client, addresses}})}
                enableDelete
                enableAdd
                enableAddressType
                enableIsPrimary
              />
              <CommunicationsView
                communications={client.communications}
                ref="communications"
                onChange={(communications)=> this.setState({client: {...this.state.client, communications}})}
              />

              { client.id > 0 ? (<ContactsView parentEntityName={'clients'} parentEntityId={client.id} isAdmin={this.props.isAdmin} />)
                : (<h5 style={{marginBottom: '30px'}}>Please save the client to add client contacts</h5>)}

              { client.id > 0 ? (<UsersByClientLocationControl
                  mode={'client'}
                  clientId={client.id}
                  onSelectUser={x => window.open(x, '_blank')}
                />)
                : (<h5 style={{marginBottom: '30px'}}>Please save the client to view client users</h5>)}

              { client.id > 0 ? (<ContractsView
                  clientId={client.id}
                  label={'Contracts'}
                  parentEntityId={client.id}
                  parentEntityName={'clients'}
                  isReadOnly={isClientUser || isLocationUser}
                />)
                : (<h5 style={{marginBottom: '30px'}}>Please save the client to add client contracts</h5>)}

              { client.id > 0 ? (<div className="form-group row">
                <div className="col-12">
                  <h6>Locations&nbsp;&nbsp;
                    <Button color="success" onClick={() => this.props.dispatch(push(`${BASE_URL}/manage/locations/-1?clientId=${client.id}`))}><i className="fa fa-plus" />&nbsp;New Location</Button></h6>
                  <table className="table">
                    <thead>
                    <tr>
                      <th>Location Name</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.client.locations.length == 0 &&
                    <tr>
                      <td>No locations</td>
                    </tr>
                    }
                    {this.state.client.locations.map(c => (
                      <tr key={c.id}>
                        <td><a href="#" onClick={(e)=> {
                          e.preventDefault();
                          this.props.dispatch(push(`${BASE_URL}/manage/locations/${c.id}`));
                        }} >{c.locationName}</a></td>
                      </tr>
                    ))}
                    </tbody>
                  </table>
                </div>
              </div>)
                : (<h5 style={{marginBottom: '30px'}}>Please save the client to add locations</h5>)}

              {(!this.props.clients.saveInfo.saving && this.props.clients.saveError.client) &&
                <span className="text-danger" style={{marginRight: '10px'}}>{this.props.clients.saveError.error}</span>}

              {this.props.clients.saveInfo.saving ?
                <div className="form-group row">
                  <div className="col-12">
                    Saving... <i className="fa fa-cog fa-spin" />
                  </div>
                </div>
                :
                <div className='mb-2'>
                  {clientValid.valid ?
                    <Button color="primary" onClick={this.handleSaveClient} style={{marginRight: '10px'}} disabled={isSalesManager || this.props.clients.saveInfo.saving}><i className="fa fa-save"/>&nbsp;Save
                      Client</Button> :
                    <span className="text-danger" style={{marginRight: '10px'}}>{clientValid.error}</span>
                  }
                  <Button color="seconday" onClick={() => {
                    if (isSalesManager || JSON.stringify(this.state.client) === JSON.stringify(this.state.originalClient) ||
                      confirm('Are you sure you want to leave without saving your changes?')) {
                      this.props.navigate(-1);
                    }
                  }}><i className="fa fa-mail-reply" />&nbsp;Cancel</Button>
              <div className='clearfix' /> 

              </div>}
            </div>
          </div>
        </div>

      </div>}
    </div>) : <div>Loading client... {this.state.message}</div>;
  }
}

EditClientView.propTypes = {
  clientId: PropTypes.number.isRequired,
  bdms: PropTypes.object,
  account: PropTypes.object.isRequired,
  onComplete: PropTypes.func,
  onLocationSelected: PropTypes.func,
  onNewLocation: PropTypes.func,
  isClientUser: PropTypes.bool.isRequired,
  isSuperUser: PropTypes.bool.isRequired,
  isSalesManager: PropTypes.bool.isRequired,
};

EditClientView.defaultProps = {
  bdms: { items: [] },
  onComplete: function() {
    // When accessed via route, use navigate instead
    if (this.props && this.props.navigate) {
      this.props.navigate(-1);
    }
  },
  onLocationSelected: () => {},
  onNewLocation: () => {},
};

function mapStateToProps(state, ownProps){
  let id = -1;
  if(ownProps.routeParams && ownProps.routeParams.id){
    id = parseInt(ownProps.routeParams.id);
  }

  let isLocationUser = false;
  let isClientUser = false;
  let isSuperUser = false;
  let isSalesManager = false;
  let {user} = state.account;

  if(user){
    isClientUser = user.hasRole(ROLE_ClientUser);
    isSuperUser = user.hasRole(ROLE_SuperUser);
    isLocationUser = user.hasRole(ROLE_LocationUser);
    isSalesManager = user.hasRole(ROLE_SalesManager);
    
    if(isSalesManager) {
      isClientUser = true;
      isLocationUser = true;
    }
  }

  return {
    clientId: id,
    isClientUser,
    isSuperUser,
    locations: state.locations,
    clients: state.clients,
    isLocationUser,
    account: state.account,
    isSalesManager,
    bdms: state.bdms || { items: [] },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditClientView));